<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" class="px-4 mt-n3">
        <v-row dark align="end">
          <div class="display-1">Afsendte</div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue2Filters from "vue2-filters";
export default {
  mixins: [Vue2Filters.mixin],
  props: ["classData"],
  computed: {}
};
</script>

<style lang="scss" scoped></style>
